module.exports = __webpack_public_path__ + "assets/img/视频号.9a96509f.jpg";